/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import GenericTween from "./GenericTween";
import { useTranslate } from "../../translate";

const containerCSS = css`
    padding: 0 16px;

    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        padding: 0 24px;
    }

    .trpr__primary-layout-itinerary-items[data-min-width~="650"] & {
        padding: 0 36px;
    }
`;
const wrapperCSS = ({ isPlaceType }) => css`
    background: #ffffff;
    color: #505050;
    border-radius: 4px;
    display: grid;
    padding: 20px 24px;
    row-gap: 12px;

    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        grid-template-columns: auto 1fr auto;
        align-items: flex-start;
    }

    ${isPlaceType &&
        `
        background: #467c6f;
        color: #ffffff;
    `}

    ${!isPlaceType &&
        `
        border: 1px solid #D5D5D5;
    `}
`;
const textCSS = css`
    color: inherit;
    font-size: 13px;
    line-height: 20px;
    margin: 0;

    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        padding: 0 36px 0 0;
    }
`;
const iconCSS = css`
    height: 20px;
    justify-self: center;
    width: 20px;

    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        margin-right: 12px;
    }
`;
const linkCSS = ({ isPlaceType }) => css`
    align-items: center;
    border-radius: 4px;
    display: inline-flex;
    height: 30px;
    justify-content: center;
    padding: 0 12px;
    text-decoration: none !important;
    background: #7875f9;
    &,
    &:hover {
        color: #ffffff;
    }

    span {
        font-weight: 600;
        font-size: 13px;
        line-height: 20px;
        color: inherit;
        transform: translateX(8px);
        transition: all 150ms ease-out;
    }

    i {
        font-size: 16px;
        color: inherit;
        display: block;
    }

    ${isPlaceType &&
        `
        box-shadow: 0px 4px 8px 0px rgba(29, 96, 80, 0.2);
        background: #ffffff;

        &,
        &:hover {
            color: #467c6f;
        }
    `}

    &:hover {
        span {
            transform: translateX(0);
        }

        .unit {
            transform: translateX(0);
            opacity: 1;
        }
    }
`;
const arrowIconCSS = css`
    position: relative;
    margin-left: 6px;
    display: flex;
    align-items: center;

    .placeholder {
        opacity: 0;
        position: relative;
    }

    .unit {
        opacity: 0;
        transition: all 150ms ease-out;
        position: absolute;
        top: 0;
        left: 0;
        transform: translateX(8px);
    }
`;

export const LinkBtn = props => {
    const { link, isPlaceType, className } = props;
    const translate = useTranslate();
    if (!link || !link.url) {
        return null;
    }
    //HACK: support legacy API structure?
    const linkURL = typeof link === "string" ? link : link.url;
    const linkLabel = link?.buttonLabel ? link.buttonLabel : translate("Learn more");
    return (
        <a
            href={linkURL}
            css={linkCSS({ isPlaceType })}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
        >
            <span>{linkLabel}</span>
            <div css={arrowIconCSS}>
                <i className="trpr__icon-forward placeholder"></i>
                <i className="trpr__icon-forward unit"></i>
            </div>
        </a>
    );
};

function Tween(props) {
    const { data, className } = props;
    const tweenType = data?.tweenType?.label;
    const isPlaceType = tweenType === "Welcome To";

    if (isPlaceType) {
        const iconUrl = data.tweenType.tweenImageURL;
        return (
            <div css={containerCSS} className={className}>
                <div css={wrapperCSS({ isPlaceType })}>
                    {iconUrl && <object css={iconCSS} type="image/svg+xml" data={iconUrl} aria-label=""></object>}
                    <p css={textCSS}>{data.text}</p>
                    <LinkBtn isPlaceType={isPlaceType} link={data.link}></LinkBtn>
                </div>
            </div>
        );
    }

    return (
        <GenericTween
            iconLabel={data.tweenType.label}
            icon={data.tweenType.tweenImageURL}
            singleLine={false}
            link={data.link}
            className={className}
        >
            {data.text}
        </GenericTween>
    );
}

export default Tween;
